import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/*
This is now the dead dialong. not a generic dialog.
*/


@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css']
})
export class GenericDialogComponent implements OnInit {

  selected: string;
  question: string;
  longDescription: string;
  reasons: string[];
  type: string;
  constructor(private dialogRef: MatDialogRef<GenericDialogComponent>,
@Inject(MAT_DIALOG_DATA) data) {
  let quest = data.question;
  let longDes = data.desc;
  this.longDescription = data.desc;

  this.question = data.question;
  this.reasons = data.reasons;
  this.type = data.type;
//   this.form = this.fb.group({
//          question: [quest, []],
//           // category: [category, Validators.required],
//           // releasedAt: [moment(), Validators.required],
//          longDescription: [longDes,Validators.required]
// });
  }

  ngOnInit() {

  }

  save() {
    console.log("Selected reason is ", this.selected);
    if(this.selected == undefined){
      console.log("reason is needed");
        return;
    }
    this.dialogRef.close(this.selected);
  }

    close() {
        this.dialogRef.close('');
}

}
